import { Container, Grid, Typography, Button, Paper, makeStyles } from '@material-ui/core';
import { ErrorIcon } from '../../../../icons/ErrorIcon';
import { QualityScore } from '../Quality';
import { useAppStateContext } from '../../../AppStateProvider/AppStateProvider';
import { ViewIcon } from '../../../../icons/ViewIcon';
import { WarningIcon } from '../../../../icons/WarningIcon';
import { PrimaryButton } from '../../../common/PrimaryButton';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  modal: {
    width: '6000px',
  },
  paper: {
    padding: '1.5em',
    borderRadius: '8px',
    '& li': {
      '&:not(:last-child)': {
        marginBottom: '1.5em',
      },
    },
  },
  paperContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '@media screen and (max-width: 950px)': {
      width: 'auto',
      paddingTop: '10px',
    },
  },
  errorIcon: {
    position: 'absolute',
    right: 'calc(100% + 18px)',
    '@media screen and (max-width: 1000px)': {
      display: 'none',
    },
  },
  viewButton: {
    marginTop: '1em',
    '& svg': {
      position: 'relative',
      left: '-5px',
    },
    '@media screen and (max-width: 950px)': {
      display: 'flex',
    },
  },
});

interface PoorQualityProps {
  quality: QualityScore | undefined;
  openModal: () => void;
}

export function PoorQuality({ quality, openModal }: PoorQualityProps) {
  const { nextPane, state, dispatch } = useAppStateContext();
  const classes = useStyles();
  const finishedDeviceCheck = !state.deviceTestIsNotFinished;
  const { t } = useTranslation('', { keyPrefix: 'SPEED' });

  function setDeviceTestIsNotFinished() {
    dispatch({ type: 'set-device-test-not-finished', state: true });
    return undefined;
  }

  function setDeviceTestIsFinished() {
    dispatch({ type: 'set-device-test-not-finished', state: false });
    nextPane();
  }

  return (
    <Container>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item md={5}>
          <Typography variant="h1" gutterBottom style={{ position: 'relative' }}>
            <div className={classes.errorIcon}>
              {quality === QualityScore.Suboptimal ? <WarningIcon /> : <ErrorIcon />}
            </div>
            {quality === QualityScore.Suboptimal ? t('QUALITY_IS_OKAY') : t('QUALITY_ISSUES')}
          </Typography>

          <Typography variant="body1" gutterBottom>
            {quality === QualityScore.Suboptimal
              ? t('SUBOPTIMAL_QUALITY_DESCRIPTION')
              : t('DEGRADED_QUALITY_DESCRIPTION')}
          </Typography>

          <Typography variant="body1" gutterBottom>
            <strong>{t('IMPROVE_QUALITY')}</strong>
          </Typography>

          <PrimaryButton
            onClick={finishedDeviceCheck ? setDeviceTestIsFinished : setDeviceTestIsNotFinished}
            style={{ marginRight: '1.5em', borderRadius: '6px' }}
          >
            {t('YES')}
          </PrimaryButton>
          <Button color="primary" disableRipple onClick={nextPane}>
            {t('SKIP_FOR_NOW')}
          </Button>
          <Button color="primary" variant="outlined" disableRipple onClick={openModal} className={classes.viewButton}>
            <ViewIcon />
            {t('VIEW_DETAILED_INFORMATION')}
          </Button>
        </Grid>

        <Grid item md={5} className={classes.paperContainer}>
          <Paper className={classes.paper}>
            <Typography variant="body1">
              <strong>{t('TIPS_TO_IMPROVE_QUALITY')}</strong>
            </Typography>

            <ul>
              <li>
                <Typography variant="body1">{t('QUALITY_TIP_1')}</Typography>
              </li>
              <li>
                <Typography variant="body1">{t('QUALITY_TIP_2')}</Typography>
              </li>
              <li>
                <Typography variant="body1">{t('QUALITY_TIP_3')}</Typography>
              </li>
              <li>
                <Typography variant="body1">{t('QUALITY_TIP_4')}</Typography>
              </li>
            </ul>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
